import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        creatingHotel: false,
        id: null,
        images: [],
        name: "",
        keyDescription: Math.random(),
        description: "",
        type: 0,
        address: "",
        city: "",
        country: "",
        stars: 0,
        price: 0,
        features: "",
        status: 0,
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.name, (error) => errors.name = error, { min: { value: 2, error: "Too short" }, max: { value: 150, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.description, (error) => errors.description = error, { min: { value: 5, error: "Too short" }, max: { value: 100000, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.address, (error) => errors.address = error, { min: { value: 2, error: "Too short" }, max: { value: 255, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.city, (error) => errors.city = error, { min: { value: 1, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.country, (error) => errors.country = error, { min: { value: 1, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.type, (error) => errors.type = error, { min: { value: 0, error: "Too low" }, max: { value: 1, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.stars, (error) => errors.stars = error, { min: { value: 0, error: "Too low" }, max: { value: 5, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.price, (error) => errors.price = error, { min: { value: 0, error: "Too low" }, max: { value: 100000000, error: "Too high" } })
    validation.addValidationRule(StringValidationRule, instance.state.features, (error) => errors.features = error, { min: { value: 0, error: "Too short" }, max: { value: 1000, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.status, (error) => errors.status = error, { min: { value: 0, error: "Too low" }, max: { value: 2, error: "Too high" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const createHotel = (instance) => {
    instance.setState({
        ...instance.state,
        creatingHotel: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/hotel/create",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            name: instance.state.name,
            description: instance.state.description,
            type: instance.state.type,
            address: instance.state.address,
            city: instance.state.city,
            country: instance.state.country,
            stars: instance.state.stars,
            price: instance.state.price,
            features: instance.state.features,
            status: instance.state.status
        }
    }).then(response => handleCreateHotelResponse(instance, response.data))
    .catch(error => alert(error))
}

const handleCreateHotelResponse = (instance, response) => {
    
    switch (response.status) {
        case 200:
            instance.setState({
                ...getDefaultState(),
                flag: {
                    type: "success",
                    text: "Hotel Created"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                creatingHotel: false,
                flag: {
                    type: "error",
                text: response.message
                }
            })
    }
}

const CreateHotelWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        createHotel: () => createHotel(instance)
    }
}

export default CreateHotelWorker
